<template>
  <chart-component>
    <!-- Title -->
    <template #title>
      {{ title }}
    </template>
    <!-- /Title -->
    <!-- Timeline Period Switcher -->
    <template #switcher>
      <timeline-period-switcher
        class="switcher"
        @change="switchChartPeriod($event)"
      />
    </template>
    <!-- /Timeline Period Switcher -->
    <!-- Chart -->
    <template #chart>
      <timeline-of-total-costs-chart
        hide-title
        :period="period"
        :height="height"
        :shared-idea="sharedIdea"
        :chart-animations="chartAnimations"
      />
    </template>
    <!-- /Chart -->
    <!-- Right side -->
    <template v-if="!hideRightSide" #right-side>
      <chart-component-right-side>
        <total-amount
          class="mb-3"
          :amount="totalAmount"
          :text="$t('charts.totalCost')"
        />
        <div>
          <template v-for="(year, index) in byYearAmount">
            <year-info
              :key="index"
              class="mb-3"
              :avatar-text="`Y${index + 1}`"
              :money="year"
              :text="getTotalExpensesEndOfYearDateString(index)"
            />
          </template>
        </div>
      </chart-component-right-side>
    </template>
    <!-- /Right side -->

    <!-- Bottom -->
    <template #bottom>
      <slot name="bottom" />
    </template>
    <!-- /Bottom -->
  </chart-component>
</template>

<script>
import ChartComponent from '@/views/Home/StoryMode/FinancialPlan/Components/ChartComponent'
import ChartComponentRightSide from '@/views/Home/StoryMode/FinancialPlan/Components/ChartComponentRightSide'
import MixinCalculations from '@/mixins/calculations'
import MixinCharts from '@/mixins/charts'
import MixinCurrencies from '@/mixins/currencies'
import TimelineOfTotalCostsChart from '@/views/Home/StoryMode/FinancialPlan/Charts/TimelineOfTotalCostsChart'
import TimelinePeriodSwitcher from '@/components/Charts/Timeline/TimelinePeriodSwitcher'
import TotalAmount from '@/views/Home/StoryMode/FinancialPlan/Components/TotalAmount'
import YearInfo from '@/views/Home/StoryMode/FinancialPlan/Components/YearInfo'

export default {
  name: 'TimelineOfTotalCosts',

  components: {
    ChartComponent,
    ChartComponentRightSide,
    TimelineOfTotalCostsChart,
    TimelinePeriodSwitcher,
    TotalAmount,
    YearInfo
  },

  mixins: [
    MixinCalculations,
    MixinCharts,
    MixinCurrencies
  ],

  // charts.totalCostsOverTime

  props: {
    title: {
      type: String,
      default () {
        return this.$t('charts.totalCostsOverTime')
      }
    },
    chartAnimations: {
      type: Boolean,
      default: false
    },
    sharedIdea: {
      type: Object,
      default: null
    },
    hideRightSide: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 370
    }
  },

  data () {
    return {
      period: 'monthly',
      dateStringPeriodEndMonth: this.getDateStringPeriodEndMonth(),
      dateStringPlanningStartYear: this.getDateStringPlanningStartYear()
    }
  },

  computed: {
    totalAmount () {
      let total = 0

      if (
        this.$store.state.idea.storyMode.forecast.totalCosts.calculation &&
        this.$store.state.idea.storyMode.forecast.totalCosts.calculation.totalExpenses &&
        this.$store.state.idea.storyMode.forecast.totalCosts.calculation.totalExpenses.data
      ) {
        total = this.calculateSumForPlanningPeriod(
          this.$store.state.idea.storyMode.forecast.totalCosts.calculation.totalExpenses.data
        )
      }

      return total
    },

    byYearAmount () {
      let byYear = []

      if (
        this.$store.state.idea.storyMode.forecast.totalCosts.calculation &&
        this.$store.state.idea.storyMode.forecast.totalCosts.calculation.totalExpenses &&
        this.$store.state.idea.storyMode.forecast.totalCosts.calculation.totalExpenses.yearTotalIncome
      ) {
        byYear = Object.values(
          this.$store.state.idea.storyMode.forecast.totalCosts.calculation.totalExpenses.yearTotalIncome
        )
      }

      return byYear
    }
  },

  methods: {
    switchChartPeriod (period) {
      this.$set(this, 'period', period)
    },

    getTotalExpensesEndOfYearDateString (year) {
      return `${this.$t('charts.endOf')} ${this.dateStringPeriodEndMonth} ${this.$moment(this.dateStringPlanningStartYear, 'YYYY').add(year + 1, 'Y').format('[\']YY')}`
    }
  }
}
</script>
